export default function RequestIcon() {
  return (
    <div className="mr-2 -ml-1">
      <img alt={'CreativeOS'} src={'/images/hotel-bell-white.png'} className={'h-5 w-6 dark:block hidden'} />
      <img alt={'CreativeOS'} src={'/images/hotel-bell.png'} className={'h-5 w-6 dark:hidden block'} />
    </div>
  )
}
